module.exports = __webpack_public_path__ + "static/flash-mobile-c01b584d79f1079b6a5e6e90240400b3.jpg";